import React from 'react';
import Icon from '../openplay/OpenPlayIcon';

const PlaceListItem = ({ place, onLocate }) => {
  const img = String(place?.coverImageThumbUrl || place?.coverImageUrl || place?.galleryUrls?.[0] || '').trim();

  return (
    <li className="p-3">
      <div className="flex items-center gap-3">
        <div className="w-12 h-12 rounded-lg bg-muted overflow-hidden flex-shrink-0">
          {img ? (
            <img
              src={img}
              alt={place?.name || 'place'}
              className="w-full h-full object-cover"
              loading="lazy"
            />
          ) : (
            <div className="w-full h-full flex items-center justify-center text-muted-foreground">
              <Icon name="PhotoIcon" size={18} />
            </div>
          )}
        </div>
        <div className="flex-1 min-w-0">
          <p className="text-sm font-semibold text-foreground truncate">{place.name}</p>
          <p className="text-xs text-muted-foreground caption truncate">{place.address}</p>
          <div className="mt-1 text-[11px] text-muted-foreground">
            {place.indoor ? '실내' : '실외'} · 이벤트 {place.eventCount}개
          </div>
        </div>
        <button
          type="button"
          onClick={onLocate}
          className="w-10 h-10 rounded-lg border border-border bg-background hover:bg-muted transition-smooth flex items-center justify-center text-muted-foreground hover:text-foreground flex-shrink-0"
          aria-label="지도에서 위치 보기"
        >
          <Icon name="MapPinIcon" size={18} />
        </button>
      </div>
    </li>
  );
};

export default PlaceListItem;
